export enum ValidationType {
  NONE = 'none', // no values
  INTEGER = 'integer', // values < 0 and > 0
  UNSIGNED_INTEGER = 'unsigned_integer', // values > 0
  DATE = 'date', // valid dates
}
